import React from 'react';

const BankIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M25.6666 22.1667V25.6667H2.33325V22.1667C2.33325 21.525 2.85825 21 3.49992 21H24.4999C25.1416 21 25.6666 21.525 25.6666 22.1667Z",
      fill: "#00FFFF",
      stroke: "#00FFFF",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.16659 12.8333H5.83325V20.9999H8.16659V12.8333Z",
      fill: "#00FFFF"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M12.8333 12.8333H10.5V20.9999H12.8333V12.8333Z", fill: "#00FFFF" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.5001 12.8333H15.1667V20.9999H17.5001V12.8333Z",
      fill: "#00FFFF"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M22.1666 12.8333H19.8333V20.9999H22.1666V12.8333Z",
      fill: "#00FFFF"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M26.8334 26.5417H1.16675C0.688415 26.5417 0.291748 26.1451 0.291748 25.6667C0.291748 25.1884 0.688415 24.7917 1.16675 24.7917H26.8334C27.3118 24.7917 27.7084 25.1884 27.7084 25.6667C27.7084 26.1451 27.3118 26.5417 26.8334 26.5417Z",
      fill: "#00FFFF"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M24.9316 6.70823L14.4316 2.50823C14.1983 2.4149 13.8016 2.4149 13.5683 2.50823L3.06825 6.70823C2.65992 6.87157 2.33325 7.3499 2.33325 7.79323V11.6666C2.33325 12.3082 2.85825 12.8332 3.49992 12.8332H24.4999C25.1416 12.8332 25.6666 12.3082 25.6666 11.6666V7.79323C25.6666 7.3499 25.3399 6.87157 24.9316 6.70823ZM13.9999 9.91657C13.0316 9.91657 12.2499 9.1349 12.2499 8.16657C12.2499 7.19823 13.0316 6.41657 13.9999 6.41657C14.9683 6.41657 15.7499 7.19823 15.7499 8.16657C15.7499 9.1349 14.9683 9.91657 13.9999 9.91657Z",
      fill: "#00FFFF"
    }
  )
);
BankIcon.displayName = "Icons.BankIcon";

export { BankIcon };
//# sourceMappingURL=BankIcon.js.map
